/* Сторис «Как пользоваться» (legacy/bot-onb.js) на настоящих данных сервера (владелец 30.10.2026): вместо демо-картинок шаблона
   (Геральт из ассетов, «ваше фото» — дефолтная девушка) — превью шаблонов «Студии», персонаж каталога с энсо своего голоса.
   Источники: главная «Студии» (строки «Сейчас в тренде»: название, подпись, кадры previews, персонажи collage_avatar_ids) и инструменты
   (экран, по которому строка узнаётся: who — кружок, shoot / pshoot — фотосессия, остальные видео-экраны — шаблоны и рилс).
   Голоса и ваше фото сторис берут сами (крючки оболочки и BotPeople): здесь только то, чего на клиенте нет. Сбой — сторис остаются на заглушках. */
import { endpoints } from '../../api';
import { accountLocale } from '../../i18n';
import { studioApi } from '../studio/studio-api';
import { record, rows, text } from '../studio/studio-content';

export interface OnbFrame {
  url: string;
  video: boolean;
}
export interface OnbData {
  /** Кружок: играющее превью шаблона (ролик или GIF), портрет и подпись персонажа, энсо его голоса */
  circle: { media: OnbFrame | null; pic: string | null; name: string; src: string; orb: string | null; row: string; caption: string } | null;
  /** Фотосессия: кадры превью шаблона и подпись строки */
  shoot: { frames: string[]; caption: string } | null;
  /** Шаблоны и рилс: до трёх строк тренда с кадром */
  apps: Array<{ name: string; caption: string; frame: OnbFrame }>;
}

const frames = (item: Record<string, unknown>, tool?: Record<string, unknown>): OnbFrame[] => {
  const own = rows(item.previews);
  return (own.length ? own : rows(tool?.previews))
    .map(p => ({ url: text(p.url), video: text(p.mime).startsWith('video/') }))
    .filter(p => p.url.startsWith('https://'));
};
const screenOf = (tool?: Record<string, unknown>) => text(record(tool?.entry).screen) || text(tool?.screen);
const APPS = ['reels', 'dance', 'video', 'scene', 'avatar', 'cover'];

let once: Promise<OnbData> | null = null;
/** Данные сторис: один запрос на сессию (повтор после сбоя — новым вызовом) */
export function onbData(): Promise<OnbData> {
  once ??= load().catch(error => {
    once = null;
    throw error;
  });
  return once;
}

async function load(): Promise<OnbData> {
  const [home, tools] = await Promise.all([studioApi.home(), studioApi.allTools()]);
  const byId = new Map(tools.items.map(t => [t.id, t as Record<string, unknown>]));
  const trend = rows(record(home.trend).items).map(item => ({ item, tool: byId.get(Number(item.tool_id)) }));
  const find = (...screens: string[]) => trend.find(t => screens.includes(screenOf(t.tool)));

  const c = find('who', 'circle');
  let circle: OnbData['circle'] = null;
  if (c) {
    const fs = frames(c.item, c.tool);
    /* играет ролик, если он есть, иначе GIF: кадр-картинка не играет — тогда портрет персонажа в кольце */
    const media = fs.find(f => f.video) ?? fs.find(f => /\.gif(\?|$)/i.test(f.url)) ?? null;
    /* персонаж кружка — первый из коллажа строки (тот же, что в плитках тренда) */
    const ids = Array.isArray(c.item.collage_avatar_ids) ? (c.item.collage_avatar_ids as unknown[]) : [];
    const id = Number(ids[0]) || 0;
    const row = text(c.item.name) || text(c.item.title),
      caption = text(c.item.caption);
    circle = { media, pic: null, name: row, src: caption, orb: null, row, caption };
    if (id) {
      const details = await endpoints.avatarCatalog.details(id, accountLocale() === 'en' ? 'en' : 'ru').catch(() => null);
      const card = details?.avatar ?? null;
      if (card) circle = { ...circle, pic: card.image_thumb_url || card.image_url || null, name: card.full_name || card.name, src: card.source };
      const voice = details?.voice_cards?.[0];
      if (voice) circle.orb = (voice as { avatar_thumb_url?: string | null; avatar_url?: string | null }).avatar_thumb_url || voice.avatar_url || null;
    }
  }

  const s = find('shoot', 'pshoot');
  const shoot = s ? { frames: frames(s.item, s.tool).filter(f => !f.video).map(f => f.url), caption: text(s.item.caption) } : null;

  const apps = trend
    .filter(t => t !== c && t !== s && APPS.includes(screenOf(t.tool)))
    .map(t => ({ name: text(t.item.name) || text(t.item.title), caption: text(t.item.caption), frame: frames(t.item, t.tool).at(-1) }))
    .filter((a): a is OnbData['apps'][number] => !!a.frame)
    .slice(0, 3);

  return { circle, shoot: shoot && shoot.frames.length ? shoot : null, apps };
}
